import { Component, signal, ViewEncapsulation } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class FooterComponent {
  readonly newsletterEmail = signal('');

  onNewsletterSubmit(event: Event): void {
    event.preventDefault();
    this.newsletterEmail.set('');
  }
}
